const isObject = (obj)=>obj && 'object' == typeof obj;
function mergeTranslations(target, source) {
    if (!isObject(target) || !isObject(source)) return source;
    const _target = {
        ...target
    };
    const keys = Object.keys(source);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const targetValue = _target[key];
        const sourceValue = source[key];
        if (isObject(targetValue) && isObject(sourceValue)) _target[key] = mergeTranslations({
            ...targetValue
        }, sourceValue);
        else if (void 0 !== sourceValue) _target[key] = sourceValue;
    }
    return _target;
}
const interpolationRegex = /\{\{(.+?)\}\}/g;
function getInterpolation(value, replacements) {
    return value.replace(interpolationRegex, (_, name)=>{
        const replacement = replacements[name];
        if (null == replacement) {
            if ('development' === process.env.NODE_ENV) console.error(`Invalid interpolation value "${name}"`);
            return '';
        }
        return replacement;
    });
}
const pipe = (...fns)=>(x)=>fns.reduce((v, f)=>f(v), x);
function transformInitialStateTranslations(translations) {
    const i18nTranslation = {};
    for(let i = 0; i < translations.length; i++){
        const translation = translations[i];
        const locales = {};
        for(let j = 0; j < translation.keys.length; j++){
            const locale = translation.keys[j];
            locales[locale.name] = locale.value;
        }
        if (!i18nTranslation[translation.language]) i18nTranslation[translation.language] = {};
        i18nTranslation[translation.language][translation.page] = locales;
    }
    return i18nTranslation;
}
function validateIsConfig(config) {
    return 'object' == typeof config;
}
function validateIsFormatterConfig(config) {
    return !!config.formatter || !!config.formatters;
}
export { getInterpolation, mergeTranslations, pipe, transformInitialStateTranslations, validateIsConfig, validateIsFormatterConfig };
